import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_the_user",
    "event": "user_signed_up"
}' <ph_client_api_host>/i/v0/e/
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "properties": {
        "login_type": "email",
        "is_free_trial": "true"
    },
    "distinct_id": "distinct_id_of_the_user",
    "event": "user_signed_up"
}' <ph_client_api_host>/i/v0/e/
`}</code></pre>
    <h3 {...{
      "id": "batching-events"
    }}>{`Batching events`}</h3>
    <p>{`Events can be sent together in a batch. There is no limit on the number of events you can send in a batch, but the entire request body must be less than `}<inlineCode parentName="p">{`20MB`}</inlineCode>{` by default.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell",
        "metastring": "label=Batch",
        "label": "Batch"
      }}>{`POST <ph_client_api_host>/batch/
Content-Type: application/json
Body:
{
    "api_key": "<ph_project_api_key>",
    "batch": [
        {
            "event": "event_name",
            "properties": {
                "distinct_id": "distinct_id_of_the_user",
                "key1": "value1",
                "key2": "value2"
            },
        },
        ...
    ]
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      